module.exports = __webpack_public_path__ + "img/visionmisionvalores.c5b49fa3.png";